import { debug, isNullOrUndefined } from "util";

cb.define([], function () {
  var AA_aa_menu_VM_extend = {

    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    // 终端切换
    terminalTypeChange: function (viewmodel) {
      let terminalType1 = viewmodel.get('terminalType1').getValue();
      if (!terminalType1) terminalType1 = "1";
      let params = {
        "simpleVOs": [{
          field: 'terminalType',
          op: 'eq',
          value1: terminalType1
        }]
      };
      return params;
    },
    //末级节点视图类型等不能为空
    isEndSet: function (viewmodel, data) {
      if (!data) {
        viewmodel.get('viewType').setState('bIsNull', true);
        viewmodel.get('menuUrl').setState('bIsNull', true);
        viewmodel.get('metaType').setState('bIsNull', true);
        viewmodel.get("authControl").setVisible(false);
      } else {
        viewmodel.get('viewType').setState('bIsNull', false);
        viewmodel.get('menuUrl').setState('bIsNull', false);
        viewmodel.get('metaType').setState('bIsNull', false);
        var isSystem=viewmodel.get("isSystem").getValue();
        if(!isSystem || isSystem=='false'){
          viewmodel.get("authControl").setVisible(true);
        }
      }
    },
    authCode: function (viewmodel, data) {
      if (data) {
        viewmodel.get("authCode_name").setVisible(true);
        viewmodel.get("authCode_name").setState('bIsNull', false);
      } else {
        viewmodel.get("authCode_name").setVisible(false);
        viewmodel.get("authCode_name").setState('bIsNull', true);
      }
    },
    init: function (viewmodel) {
      var self = this;
      viewmodel.getParams().saveRefresh = true;
      viewmodel.get('icon').setState('tooltip', '仅支持JPG、JPEG、BMP、PNG格式（建议使用PNG格式，最佳尺寸22*22px）');
      //树节点最大为2
      // viewmodel.getTreeModel().setState('maxLevel', 2);
      //添加终端切换模型，切换时同步刷树
      var terminalTypeModel = new cb.models.ListModel({ needClear: false, value: '1' });
      terminalTypeModel.setDataSource(viewmodel.get('terminalType').getState('dataSource'));
      viewmodel.addProperty('terminalType1', terminalTypeModel);
      viewmodel.get("terminalType1").on('afterValueChange', function (data) {
        viewmodel.biz.do('querytree', viewmodel);
        viewmodel.get('terminalType').setValue(data.value.value);
      });
      viewmodel.get('aa_menu').on('beforeLoad', function (data) {
        viewmodel.get("authControl").setVisible(false);
        viewmodel.get("authCode_name").setVisible(false);
      });
      //菜单节点选择时，按钮状态变化
      viewmodel.get('aa_menu').on('afterSelect', function (data) {
        var level = 1;
        if (data[0]) {
          level = data[0].level;
          viewmodel.get("level").setValue(level);
        }
        if ((data[0] && data[0].isSystem)) {
          viewmodel.get("btnDelete").setDisabled(true);
          viewmodel.get("btnSave").setDisabled(true);
          viewmodel.get("btnAbandon").setDisabled(true);
          viewmodel.get("icon").setVisible(false);
        } else {
          viewmodel.get("btnDelete").setDisabled(false);
          viewmodel.get("btnSave").setDisabled(false);
          viewmodel.get("btnAbandon").setDisabled(false);
          if (data[0].parentCode != null) {
            viewmodel.get("icon").setVisible(false);
          } else {
            viewmodel.get("icon").setVisible(true);
          }
        }
        if (viewmodel.get("btnAdd")) {
          if ((data[0] && data[0].isEnd) || level >= 3) {
            viewmodel.get("btnAdd").setDisabled(true);
          } else {
            viewmodel.get("btnAdd").setDisabled(false);
          }
        };
        let flag = false;
        if (data[0] && data[0].isEnd && !data[0].isSystem) flag = true;
        self.isEndSet(viewmodel, flag);
        let authCodeFlag = false;
        if (data[0] && data[0].authControl == "2") authCodeFlag = true;
        self.authCode(viewmodel, authCodeFlag);
        viewmodel.get("code").setDisabled(true);
      });
      //新增按钮点击时
      viewmodel.get("btnAdd").on('click', function () {
        viewmodel.get("btnSave").setDisabled(false);
        viewmodel.get("btnAbandon").setDisabled(false);
        viewmodel.get("code").setDisabled(false);
      });
      //树参数写入
      var treeModel = viewmodel.getTreeModel();
      treeModel.on('beforeLoad', function (params) {
        let extendParams = self.terminalTypeChange(viewmodel);
        params.condition = extendParams;

      });
      let valModel = viewmodel.get('authCode_name');
      valModel && valModel.on('beforeValueChange', ({ value }) => {
        if (value) {
          if (!value.isEnd) {
            cb.utils.alert('请选择末级节点', 'warning');
            return value.isEnd
          }
        }
      });
      //参照参数写入
      var menuReferModel = viewmodel.get("parent_name");
      if (menuReferModel) {
        menuReferModel.on('beforeBrowse', function (params) {
          menuReferModel.setFilter(self.terminalTypeChange(viewmodel));
        });
        menuReferModel.on('afterValueChange', function (data) {
          if (data.value) {
            viewmodel.get("icon").setVisible(false);
          } else {
            viewmodel.get("icon").setVisible(true);
          }
        })
      }

      //viewType 视图类型修改后同步修改menuType的数据源
      viewmodel.get("viewType").on('afterValueChange', function (data) {
        if (data && data.value && data.value.value) {
          switch (data.value.value) {
            case "meta":
              viewmodel.get("metaType").setDataSource([
                { value: 'voucherlist', text: '单据列表' },
                { value: 'ArchiveList', text: '档案列表' },
                { value: 'treeArchive', text: '树卡' }
              ]); break;
            case "platform":
              viewmodel.get("metaType").setDataSource([
              ]); break;
            case "ajax":
              viewmodel.get("metaType").setDataSource([
                { value: '{"type":"window"}', text: '内部链接打开' }
              ]); break;
            case "external":
              viewmodel.get("metaType").setDataSource([
                { value: '{"type":"window", "mode":"fullscreen"}', text: '自定义弹出' },
                { value: '{"type":"iframe"}', text: '自定义嵌入' }
              ]); break;
          }
        }
      });
      viewmodel.get("isEnd").on("beforeValueChange", function (data) {
        var  authControl=viewmodel.get("authControl").getValue()
        if(authControl!=0){
          cb.utils.alert('已做权限控制，请先切换到无权限', 'warning');
          return false ;
        }
      });
      //是否末级改变前
      viewmodel.get("isEnd").on("afterValueChange", function (data) {
        self.isEndSet(viewmodel, data.value);
      });

      viewmodel.get("authControl").on("beforeValueChange", function (data) {
        var authControl ="0";
        if(data && data.oldValue)authControl=data.oldValue.value
        if (authControl != "0") {
          var promise = new cb.promise();
          var url = '/auth/checkQuery';
          var params = {
            "authCode": viewmodel.get("authCode1").getValue(),
            "menuCode": viewmodel.get("code").getValue(),
            "authControl": authControl
          }
          var proxy = cb.rest.DynamicProxy.create({ ensure: { url: url, method: "POST" } });
          proxy.ensure(params, function (err, result) {
            if (err) {
              cb.utils.alert(err.message, 'error');
              promise.reject();
            }
            if(result==false){
              cb.utils.alert("自定义权限已经被引用，不能修改", 'error');
              promise.reject() ;
            }else{
              let flag = data && data.value && data.value.value == "2";
              self.authCode(viewmodel, flag);
              promise.resolve()
            }
          });
          return promise;
        }else{
          let flag = data && data.value && data.value.value == "2";
          self.authCode(viewmodel, flag);
        } 
      });

      viewmodel.on('afterAdd', function () {
        viewmodel.get('terminalType').setValue(viewmodel.get('terminalType1').getValue());
        if (viewmodel.get('parentCode').getValue() != null) {
          viewmodel.get("icon").setVisible(false);
        } else {
          viewmodel.get("icon").setVisible(true);
        }
      })

      //保存前事件处理
      /*   viewmodel.on('beforeSave',function(data){
         let dataValue=JSON.parse(data['data'].data)
         dataValue.terminalType=viewmodel.get('terminalType1').getValue();
         data['data'].data=JSON.stringify(dataValue);
       });  */
    }

  }
  try {
    module.exports = AA_aa_menu_VM_extend;
  } catch (error) {

  }
  return AA_aa_menu_VM_extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_menu_VM.Extend.js